// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"0fd9c914","736":"afd0d884"}[chunkId] + ".chunk.css";
};